import { Link } from 'react-router-dom';
import { SITELINK } from '../../app-routes/Links';
import { LuSearch } from 'react-icons/lu';
import { useState } from 'react';
import { getUser, getFirstLetters } from '../../app-utils';
import { UserInterface } from '../../app-schemas/profile.schema';
import PullOutNav from '../../layouts/~includes/PullOutNav';
import { useTheme } from '../../context/theme-context';

const CommunityTopBar = () => {
  const [isNav, setNav] = useState(false);
  const user: UserInterface = getUser();
  const { isDarkMode } = useTheme();

  const renderProfilePicture = () =>
    user.profile_picture_url ? (
      <img
        alt="profile"
        src={user.profile_picture_url}
        className="object-cover rounded-full flex-none bg-gray-200 shadow-sm w-[42px] h-[42px]" // 48px for perfect circle
      />
    ) : (
      <div className="flex items-center justify-center flex-none w-[42px] h-[42px] bg-[#223f64] rounded-full border border-green-100">
        <h3 className="text-white text-[1.2rem] uppercase font-[600]">
          {getFirstLetters(user.first_name ?? user.username)}
        </h3>
      </div>
    );

  const openNav = () => setNav(true);
  const closeNav = () => setNav(false);

  return (
    <>
      <section className="items-center bg-white dark:bg-neutral-800 px-2 py-2 flex gap-3 item-center justify-between">
        {/* Menu Button - Fixed width */}
        <button 
          type="button" 
          className="flex-none px-1" 
          onClick={openNav}
          aria-label="Menu"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 20L3 20V18L21 18V20ZM15 13L3 13V11L15 11L15 13ZM21 6L3 6V4L21 4V6Z"
              fill={isDarkMode ? "white" : "black"}
              fillOpacity={isDarkMode ? "1": "0.5"}
            />
          </svg>
        </button>

        {/* Search Bar - Takes remaining space but doesn't compress neighbors */}
        <Link
          to={SITELINK.APP_SEARCH}
          className="flex-1 flex justify-center items-center gap-2 text-sm p-2 px-4 border-[#E7ECF0] text-start text-gray-600 font-[400] border rounded-[50px] bg-[#E7ECF0] min-w-0"
        >
          <LuSearch className="text-[20px] flex-none" />
          <span className="text-[14px] truncate">
            Search <b className="madimi-one">Catapot</b>
          </span>
        </Link>

        {/* Profile Picture - Fixed width, no compression */}
        <Link 
          to={`${SITELINK.MY_PROFILE}/${user?.username}`} 
          className="flex-none w-[55px] block pr-1"
          aria-label="Profile"
        >
          {renderProfilePicture()}
        </Link>
      </section>
      <PullOutNav action={isNav} onClose={closeNav} />
    </>
  )
}

export default CommunityTopBar;